import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import DistributionPage from './DistributionPage.jsx';

/** Distribution domain routes (CT-3900), mounted at /admin-studio/distribution. */
const DistributionRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <ProtectedRoute>
          <DistributionPage />
        </ProtectedRoute>
      }
    />
    <Route path="*" element={<Navigate to="." replace />} />
  </Routes>
);

export default DistributionRoutes;
